import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCustomerDetails } from '../common/api/clients/company.api';

export const Route = createFileRoute('/_app/customer/detail/$id')({
    beforeLoad: async ({ params }) => {
        const customer = await getCustomerDetails(params.id);
        const groupId = customer.customerGroupId;
        throw redirect({
            to: '/customer-groups/$groupId/companies/$companyId',
            params: { groupId: groupId, companyId: params.id },
        });
    },
});
